import { put } from 'redux-saga/effects';
import _ from 'lodash';
import { errors } from './errors';
import { onDataError } from '@containers/Admin/shared/ResourcesWrapper/actions';
import {
  getPasswordResetRequiredActions,
  getUnauthorizedActions,
} from './pendingAuthService';

/**
 * Function gets an error and returns an action
 * @param {*} error
 */
export const handleRequestErrors = (error) => {
  const graphQlErrorCode = _.get(error, ['graphQLErrors', 0, 'extensions', 'code']);

  // normal connection error
  if (_.get(error, ['networkError', 'statusCode']) === 401) {
    throw new Error(errors.UNAUTHORIZED_CONNECTION_INVALID_TOKEN);
  } else if (graphQlErrorCode === 'FORBIDDEN') {
    throw new Error(errors.WRONG_DATA);
  } else if (_.get(error, ['networkError', 'statusCode']) >= 400) {
    throw new Error(errors.CONNECTION_ERROR);
  } else if (error.toString().includes('Cannot read properties')) {
    throw new Error(errors.WRONG_DATA);
  }
};

function getActionsFromError(error) {
  let returnedActions;
  switch (error.message) {
    case errors.UNAUTHORIZED_CONNECTION_INVALID_TOKEN:
      returnedActions = getUnauthorizedActions(error.message);
      break;
    case errors.PASSWORD_RESET_REQUIRED:
      returnedActions = getPasswordResetRequiredActions();
      break;
    case errors.WRONG_DATA:
      returnedActions = [onDataError()];
      break;
    default:
      console.error(error);
  }
  return returnedActions;
}

export function* authenticationWrapper(
  codeBlockGenerator,
  errorHandlerGenerator
) {
  let returnedValue = null;
  try {
    returnedValue = yield codeBlockGenerator();
  } catch (error) {
    const authenticationErrorActions = getActionsFromError(error);
    if (authenticationErrorActions) {
      for (
        let index = 0;
        index < authenticationErrorActions.length;
        index += 1
      ) {
        yield put(authenticationErrorActions[index]);
      }
    } else if (errorHandlerGenerator) {
      yield errorHandlerGenerator();
    }
  }
  return returnedValue;
}
